import styled from 'styled-components';
import StatusDefault, { getStatusColor, type StatusProps } from './StatusDefault';

const StyledStatus = styled(StatusDefault)`
    background: transparent;
    border: 2px solid ${getStatusColor};
`;

function StatusStroke(props: StatusProps) {
    return <StyledStatus {...props} />;
}

export default StatusStroke;
